import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// import { browserHistory } from 'react-router';

// MATERIAL-UI
import Layout from '../Layout';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { miEdgeOrange500, white } from 'styles/miEdgeColors';

import AppAuth from 'AppAuth';
import { ZYW_LEADS_LOGOUT_REDIRECT } from 'lib/config/appConstants';
import { isZywaveUrl } from 'lib/AppHelpers';
import InternalError from 'components/InternalError';
import MiZuiSpinner from 'components/common/MiZuiSpinner';

/**
 * Top level component for the Login view
 */

class Login extends React.Component {
  getInitialState = () => {
    return {
      username: '',
      password: '',
      lastLoginFailed: false,
    };
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentDidMount = () => {
    // If user logged in on miEdge (has session already)
    AppAuth.getUserInfo()
      .then((json) => {
        this.props.userDidLogin(json);
      })
      .catch(() => {
        // Do nothing
      });
  };

  render() {
    let loginRetryCount = localStorage.getItem('ZYWAVE-LEADS:LOGIN_COUNT') || 0;

    if (isZywaveUrl()) {
      if (loginRetryCount > 2) {
        // on 3rd failure redirect to error page
        localStorage.removeItem(ZYW_LEADS_LOGOUT_REDIRECT);
        window.history.pushState(null, null, '/');
        return <InternalError />;
      }

      setTimeout(() => {
        // try again in 3 seconds...
        loginRetryCount++;
        localStorage.setItem('ZYWAVE-LEADS:LOGIN_COUNT', loginRetryCount);
        const redirectUrl = localStorage.getItem(ZYW_LEADS_LOGOUT_REDIRECT);
        window.location.href = redirectUrl || '/';
      }, 3000);
    }

    if (isZywaveUrl() && loginRetryCount) {
      return (
        <Layout layoutType={'noHeader'}>
          <MiZuiSpinner active />
        </Layout>
      );
    }

    return isZywaveUrl() ? (
      <Layout layoutType={'noHeader'}>
        <MiZuiSpinner active />
      </Layout>
    ) : (
      <Layout onAppError={() => null}>
        <div onKeyPress={this.onKeyPress} className="col-xs-offset-1 col-xs-6">
          <TextField
            variant="standard"
            name="username"
            fullWidth={true}
            onChange={this.textFieldChanged}
            label="User name"
          />
          <br />
          <TextField
            variant="standard"
            name="password"
            type="password"
            fullWidth={true}
            onChange={this.textFieldChanged}
            label="Password"
          />
          <br />
          <Button
            id="login"
            variant="contained"
            color="primary"
            sx={(theme) => ({
              margin: theme.spacing(1),
            })}
            onClick={this.login}
            size="large"
          >
            Login
          </Button>
          <br />
          <Button
            component={Link}
            to="/edge/forgotpassword"
            sx={(theme) => ({
              margin: theme.spacing(1),
              textTransform: 'None',
              fontSize: '14px',
              color: miEdgeOrange500,
              '&:hover': {
                backgroundColor: white,
              },
            })}
          >
            Forgot Login?
          </Button>
        </div>
        <Snackbar
          open={this.state.lastLoginFailed}
          ContentProps={{
            sx: {
              fontStyle: 'normal',
              backgroundColor: miEdgeOrange500,
            },
          }}
          message="Incorrect Username/Password. Please try again."
          autoHideDuration={4000}
          onClose={this.handleSnackbarRequestClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        />
      </Layout>
    );
  }

  /**
   * Function to update the local state when a TextField is update by the user
   * @param event
   */
  textFieldChanged = (event) => {
    const { name, value } = event.target;
    var newState = { ...this.state };
    newState[name] = value;

    this.setState(newState);
  };

  /**
   * Login to the service, and go to the main page if successful or logout if not
   */
  login = () => {
    AppAuth.login(this.state.username, this.state.password)
      .then((json) => {
        this.props.userDidLogin(json);
      })
      .catch(() => {
        AppAuth.logout();
        this.setState({ lastLoginFailed: true });
      });
  };

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.login();
    }
  };

  handleSnackbarRequestClose = () => {
    this.setState({ lastLoginFailed: false });
  };
}

Login.propTypes = {
  userDidLogin: PropTypes.func.isRequired,
};

export default Login;
